module.exports = __webpack_public_path__ + "img/zy_icon.3737d56d.png";